var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 254,
    viewBox: "0 0 282 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.622 143.837C103.783 144.289 96.2381 137.135 95.7649 127.865C95.2916 118.596 102.069 110.71 110.908 110.258L112.621 143.825L112.622 143.837Z",
    fill: "url(#paint0_linear_10521_54766)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M249.368 136.224C258.207 135.773 264.984 127.887 264.511 118.617C264.038 109.347 256.493 102.193 247.654 102.645L249.367 136.212L249.368 136.224Z",
    fill: "url(#paint1_linear_10521_54766)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M252.956 122.503C254.748 157.596 222.886 168.033 183.042 170.069C143.198 172.105 110.439 164.97 108.648 129.877L108.312 123.301C106.521 88.2077 138.382 77.7711 178.226 75.7352C218.07 73.6992 250.829 80.8338 252.62 115.927L252.956 122.503Z",
    fill: "url(#paint2_linear_10521_54766)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M210.547 76.7458C207.273 80.2349 205.226 84.8307 204.451 90.643C204.209 92.4843 202.671 93.8691 200.807 93.9644L157.606 96.1718C155.754 96.2665 154.071 95.0337 153.643 93.2392C152.292 87.5355 149.776 83.1728 146.163 80.0356C150.953 82.5528 153.783 84.7596 155.053 90.1066C155.451 91.8031 157.031 92.9541 158.771 92.8652L199.299 90.7943C201.039 90.7054 202.481 89.4001 202.716 87.6711C203.435 82.2225 206.072 78.4425 210.535 76.7464L210.547 76.7458Z",
    fill: "#066CFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M238.429 127.265C239.422 146.722 213.975 152.912 182.286 154.531C150.598 156.15 124.652 152.587 123.659 133.129L123.473 129.481C122.479 110.024 147.927 103.834 179.615 102.215C211.304 100.595 237.249 104.159 238.243 123.616L238.429 127.265Z",
    fill: "url(#paint3_linear_10521_54766)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M238.242 123.616L238.428 127.264C238.44 127.487 238.45 127.698 238.461 127.909C236.936 109.014 211.22 105.551 179.879 107.152C148.539 108.754 123.31 114.82 123.716 133.772C123.706 133.561 123.694 133.338 123.683 133.127L123.497 129.479C122.504 110.022 147.951 103.832 179.64 102.213C211.328 100.594 237.274 104.157 238.267 123.614L238.242 123.616Z",
    fill: "#131E2E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M165.591 132.939C166.009 134.299 164.805 135.605 163.419 135.315C160.206 134.645 156.941 134.402 153.696 134.567C150.451 134.733 147.228 135.309 144.1 136.302C142.738 136.732 141.419 135.556 141.697 134.16C142.794 128.779 147.416 124.599 153.172 124.305C158.928 124.011 163.952 127.698 165.591 132.939Z",
    fill: "#066CFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M196.682 131.352C196.404 132.747 197.736 133.923 199.085 133.493C202.213 132.5 205.436 131.924 208.681 131.759C211.926 131.593 215.191 131.837 218.404 132.506C219.802 132.795 220.994 131.49 220.576 130.131C218.937 124.889 213.913 121.202 208.157 121.496C202.401 121.791 197.778 125.971 196.682 131.352Z",
    fill: "#066CFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M245.573 203.379C258.367 194.972 264.835 179.43 267.068 172.901C269.495 165.824 266.315 160.721 256.683 164.341C249.255 167.142 241.531 172.017 235.221 177.699C229.69 182.685 225.113 189.006 223.443 195.859C223.019 197.581 223.084 199.334 223.606 200.954C224.924 205.094 229.022 207.686 233.665 207.319C237.794 206.987 242.043 205.692 245.579 203.363L245.573 203.379Z",
    fill: "url(#paint4_linear_10521_54766)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M220.431 198.897C220.431 203.867 219.672 208.961 218.29 213.869C201.959 228.171 176.391 227.662 157.047 213.857C155.665 208.949 154.918 203.854 154.918 198.897C154.918 177.003 169.582 173.412 187.681 173.412C205.78 173.412 220.431 177.003 220.431 198.897Z",
    fill: "url(#paint5_linear_10521_54766)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M218.291 213.869C213.585 230.594 201.648 245.144 187.669 245.144C173.69 245.144 161.74 230.581 157.047 213.857C157.756 213.832 158.478 213.77 159.188 213.67C164.565 212.937 169.644 210.266 173.291 206.252C175.656 203.655 177.412 200.537 179.864 198.027C179.889 198.002 179.901 197.989 179.926 197.965C184.046 193.815 190.793 193.815 194.913 197.965C194.938 197.989 194.951 198.002 194.976 198.027C197.44 200.537 199.195 203.655 201.548 206.252C205.195 210.266 210.274 212.937 215.652 213.67C216.535 213.795 217.419 213.857 218.303 213.869H218.291Z",
    fill: "url(#paint6_linear_10521_54766)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M187.818 183.017C200.605 183.017 210.971 181.125 210.971 178.792C210.971 176.459 200.605 174.568 187.818 174.568C175.031 174.568 164.665 176.459 164.665 178.792C164.665 181.125 175.031 183.017 187.818 183.017Z",
    fill: "url(#paint7_radial_10521_54766)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M129.037 208.431C115.604 201.083 107.9 186.114 105.146 179.787C102.155 172.93 104.911 167.587 114.805 170.417C122.435 172.609 130.528 176.845 137.277 181.999C143.193 186.522 148.267 192.453 150.486 199.149C151.047 200.831 151.124 202.584 150.735 204.24C149.757 208.473 145.882 211.387 141.224 211.396C137.082 211.398 132.742 210.45 129.029 208.415L129.037 208.431Z",
    fill: "url(#paint8_linear_10521_54766)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M101.305 93.1786L90.9085 74.855C97.3387 64.4199 99.6332 51.9571 97.341 39.9162C95.0488 27.8753 88.3357 17.1273 78.5213 9.78466C68.7068 2.44206 56.5009 -0.964005 44.3026 0.235964C32.1044 1.43593 20.7961 7.15515 12.6006 16.2694C4.40506 25.3837 -0.084975 37.2339 0.0130463 49.4906C0.111068 61.7473 4.79006 73.5241 13.1303 82.5062C21.4706 91.4882 32.8689 97.0258 45.0847 98.0306C57.3006 99.0353 69.4505 95.4344 79.1463 87.9358L101.305 93.1786Z",
    fill: "#FAFAFA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M101.305 93.1788L79.1152 88.02H79.0154L79.0785 87.9359L79.173 88.0305C77.6941 89.1619 76.1562 90.2141 74.5658 91.1825C72.8036 92.2501 70.9792 93.2114 69.1023 94.0613C64.8321 95.9638 60.3126 97.248 55.68 97.8753C53.1123 98.22 50.5211 98.3588 47.9313 98.2903C45.1811 98.2388 42.4407 97.947 39.7413 97.4182C30.1898 95.5529 21.4061 90.8968 14.5013 84.0387C7.59646 77.1806 2.88071 68.4287 0.950566 58.8901C-0.474677 51.6882 -0.295312 44.2607 1.4759 37.136C2.40523 33.4686 3.7574 29.9216 5.50523 26.5663C5.92024 25.7047 6.42456 24.8904 6.89736 24.0604C7.37016 23.2304 7.93753 22.4214 8.46286 21.6018C9.55366 20.0061 10.7359 18.4748 12.0036 17.0157C15.8629 12.5709 20.4804 8.84628 25.6413 6.01514C26.4976 5.57386 27.3434 5.11681 28.2155 4.71231C29.0875 4.3078 29.9543 3.90329 30.8422 3.57233C34.3492 2.16383 38.0069 1.16435 41.7429 0.593678C45.3941 0.0538028 49.0936 -0.0836089 52.7749 0.183915C59.8269 0.687692 66.685 2.71861 72.8742 6.13596C84.0059 12.3049 92.3261 22.5334 96.0993 34.6879C96.9096 37.3373 97.4931 40.0508 97.8434 42.7991C98.0378 44.1335 98.1113 45.4573 98.2007 46.7549C98.29 48.0525 98.2847 49.3343 98.2374 50.5898C98.106 55.2628 97.3046 59.8926 95.8576 64.3379C94.6379 68.0347 92.9875 71.5753 90.9405 74.8866V74.8183L101.279 93.1788L90.8249 74.8866V74.8498V74.8183C92.8464 71.5169 94.4754 67.9908 95.679 64.3116C97.1107 59.8801 97.8997 55.2663 98.022 50.6108C98.0641 49.3605 98.022 48.084 97.98 46.7864C97.938 45.4888 97.8119 44.1597 97.6175 42.8516C96.158 31.6967 90.8935 21.3872 82.7131 13.6642C74.5326 5.9413 63.9375 1.27816 52.7171 0.462344C49.062 0.198359 45.389 0.335766 41.7639 0.872105C38.0493 1.44183 34.4127 2.43778 30.9262 3.84025C30.0331 4.16596 29.1768 4.58623 28.2995 4.97497C27.4222 5.36372 26.5922 5.83127 25.7411 6.2673C24.0506 7.19737 22.4158 8.22527 20.845 9.34576C19.2782 10.4677 17.7752 11.6761 16.3429 12.9653C13.4707 15.5898 10.9111 18.5372 8.71503 21.7489C8.18969 22.5527 7.66436 23.3249 7.17579 24.1655C6.68723 25.006 6.20917 25.8045 5.79416 26.6608C4.05578 29.9961 2.71067 33.5219 1.78585 37.1675C0.0253668 44.2527 -0.153988 51.6385 1.26052 58.8008C3.17498 68.2923 7.8622 77.0026 14.7289 83.8291C21.5957 90.6556 30.3333 95.2916 39.8359 97.1503C42.5098 97.6903 45.2254 97.9979 47.9523 98.0696C55.2107 98.2646 62.4202 96.8285 69.0498 93.867C72.6288 92.2713 76.0044 90.2537 79.1047 87.8571L79.5092 87.5577L79.2045 87.9569L79.1678 87.8466L101.305 93.1788Z",
    fill: "#182436"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.011 78.787C67.61 78.787 81.0661 65.3309 81.0661 48.732C81.0661 32.1331 67.61 18.677 51.011 18.677C34.4121 18.677 20.9561 32.1331 20.9561 48.732C20.9561 65.3309 34.4121 78.787 51.011 78.787Z",
    fill: "#407BFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M76.0805 54.6324C79.3497 40.7808 70.7711 26.9016 56.9195 23.6324C43.068 20.3631 29.1888 28.9418 25.9195 42.7933C22.6503 56.6449 31.2289 70.524 45.0805 73.7933C58.932 77.0626 72.8112 68.4839 76.0805 54.6324Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8048 61.0388C47.4557 61.0463 47.1084 60.9849 46.783 60.858C46.4576 60.7311 46.1605 60.5412 45.9086 60.2993L34.9675 49.5857C34.4645 49.0978 34.176 48.4302 34.1653 47.7297C34.1547 47.0291 34.4227 46.353 34.9106 45.8501C35.3984 45.3472 36.066 45.0587 36.7666 45.048C37.4671 45.0373 38.1432 45.3054 38.6461 45.7932L47.6152 54.5727L63.1263 37.2603C63.6019 36.7809 64.2433 36.5024 64.9183 36.4821C65.5932 36.4619 66.2502 36.7015 66.7536 37.1514C67.2571 37.6014 67.5687 38.2275 67.6241 38.9004C67.6795 39.5734 67.4745 40.242 67.0514 40.7682L49.7011 60.1286C49.4617 60.3963 49.1699 60.6119 48.8437 60.762C48.5174 60.912 48.1638 60.9933 47.8048 61.0009V61.0388Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10521_54766",
    x1: 95.7649,
    y1: 127.865,
    x2: 111.765,
    y2: 127.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10521_54766",
    x1: 248.511,
    y1: 119.435,
    x2: 264.511,
    y2: 118.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10521_54766",
    x1: 108.48,
    y1: 126.589,
    x2: 252.789,
    y2: 119.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10521_54766",
    x1: 179.916,
    y1: 108.109,
    x2: 182.126,
    y2: 151.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#304059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131E2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10521_54766",
    x1: 242.213,
    y1: 178.266,
    x2: 252.201,
    y2: 195.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10521_54766",
    x1: 187.668,
    y1: 207.855,
    x2: 187.668,
    y2: 180.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10521_54766",
    x1: 187.669,
    y1: 229.687,
    x2: 187.669,
    y2: 197.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D4FC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_10521_54766",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(187.818 184.831) scale(22.1075 4.41352)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#066CFF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10521_54766",
    x1: 130.062,
    y1: 183.03,
    x2: 121.481,
    y2: 200.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D4FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError5);
export default __webpack_public_path__ + "static/media/error 5.f399173840d559661ad7ad4267a558ca.svg";
export { ForwardRef as ReactComponent };